import React from 'react';

import {
  Alert
} from 'react-bootstrap';


export default function ShowAlert(props) {
  if (props.message === undefined || props.message.length === 0) {
    return null;
  }
  return (
    <Alert bsStyle={props.alert}>
      { typeof(props.message === 'string') ? props.message : props.message.join(', ')}
    </Alert>
  );
}



// WEBPACK FOOTER //
// ./src/alert.js